import React, {useState} from 'react';
import SearchIcon from '@mui/icons-material/Search';
import Spinner from '../components/Spinner.js';
import SubscriptionList from '../components/SubscriptionList.jsx';
import {Box, Container, Grid, TextField, Typography} from '@mui/material';
import {getFeeds, getSubscriptions} from '../api.js';
import {useQuery} from '@tanstack/react-query';

const Overview = () => {
  const [filter, setFilter] = useState('');
  // TODO: Handle pagination
  const subscriptionsQuery = useQuery({
    queryKey: ['subscriptions'],
    queryFn: () => getSubscriptions(),
  });
  const feedsQuery = useQuery({queryKey: ['feeds'], queryFn: () => getFeeds()});

  if (subscriptionsQuery.isLoading || feedsQuery.isLoading) {
    return <Spinner />;
  }

  return (
    <Container
      maxWidth="xl"
      sx={{
        flex: 1,
        flexDirection: 'column',
        display: 'flex',
        height: '100%',
      }}
    >
      <Box padding={2} pt={2}>
        <Grid container>
          <Grid item xs={6}>
            <Typography gutterBottom variant="h4">
              My subscriptions
            </Typography>
          </Grid>
          <Grid item xs={6} align="right">
            <TextField
              InputProps={{
                startAdornment: <SearchIcon sx={{color: '#738486'}} />,
                placeholder: 'Search',
              }}
              variant="standard"
              sx={{paddingRight: 0.5}}
              value={filter}
              onChange={evt => setFilter(evt.target.value)}
            />
          </Grid>
        </Grid>
      </Box>
      <SubscriptionList
        style={{flex: 1}}
        filter={filter}
        subscriptions={subscriptionsQuery.data}
        feeds={feedsQuery.data}
      />
    </Container>
  );
};

export default Overview;
